<template>
  <div>
    <a-card v-if="listEnable" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="16" v-if="enterpriseId == ''">
            <a-col :span="6">
              <a-form-item label="安装类别">
                <a-select v-model="queryParam.installType" allowClear="true">
                  <a-select-option v-for="type in restaurantTypes" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业名称">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange"
                  v-model="queryParam.enterpriseName"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data" :title="item.enterpriseName" :key="item.enterpriseId">{{
                    item.enterpriseName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="购买渠道名称">
                <a-input v-model="queryParam.channelName" />
              </a-form-item>
            </a-col>
            <a-col :span="6" :style="{ textAlign: 'right' }">
              <a-button v-if="listEnable" type="primary" htmlType="submit" @click="$refs.table.refresh(true)"
                >查询</a-button
              >
              <a-button @click="qingkong" style="margin-left: 8px">清空</a-button>
            </a-col>
          </a-row>
          <a-row :gutter="16" v-if="enterpriseId != ''">
            <a-col :span="6">
              <a-form-item label="安装类别">
                <a-select v-model="queryParam.installType" allowClear="true">
                  <a-select-option v-for="type in restaurantTypes" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!--<a-col :span="6">-->
            <!--<a-form-item label="企业名称">-->
            <!--<a-select-->
            <!--showSearch-->
            <!--optionFilterProp="children"-->
            <!--@change="handleChange"-->
            <!--v-model="queryParam.enterpriseName"-->
            <!--:filterOption="filterOption"-->
            <!--allowClear="true"-->
            <!--&gt;-->
            <!--<a-select-option v-for="item of data" :title="item.enterpriseName" :key="item.enterpriseId">{{item.enterpriseName}}</a-select-option>-->
            <!--</a-select>-->
            <!--</a-form-item>-->
            <!--</a-col>-->
            <a-col :span="6">
              <a-form-item label="购买渠道名称">
                <a-input v-model="queryParam.channelName" />
              </a-form-item>
            </a-col>
            <a-col :span="12" :style="{ textAlign: 'right' }">
              <a-button type="primary" htmlType="submit" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button @click="qingkong" style="margin-left: 8px">清空</a-button>
            </a-col>
          </a-row>
          <a-divider></a-divider>
          <a-row>
            <a-col :span="5" :offset="19" style="text-align: end">
              <a-button
                v-if="addEnable"
                type="primary"
                style="margin-left: 8px"
                icon="plus"
                @click="$refs.modal.add(enterpriseId)"
                >新增</a-button
              >
              <!--<a-dropdown v-if="removeEnable&&selectedRowKeys.length > 0">-->
              <!--<a-button type="danger" icon="delete" style="width: 120px;" @click="delByIds(selectedRowKeys)">删除</a-button>-->
              <!--</a-dropdown>-->
            </a-col>
          </a-row>
        </a-form>
      </div>

      <s-table
        style="margin-top: 20px"
        size="default"
        ref="table"
        rowKey="channelId"
        :columns="columns"
        :data="loadData"
        bordered
      >
        <span slot="installType" slot-scope="text, record">
          <td v-for="type in restaurantTypes" :key="type.code" v-if="record.installType == type.code">
            {{ type.label }}
          </td>
        </span>
        <span slot="action" slot-scope="text, record">
          <a v-if="channelDetail" @click="handleShow(record)">查看</a>
          <a-divider v-if="channelDetail" type="vertical" />
          <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
          <a-divider v-if="removeEnable && editEnabel" type="vertical" />
          <a v-if="removeEnable" @click="delByIds(record.channelId)">删除</a>
          <span v-if="editEnabel">
            <a-divider type="vertical" />
            <a v-if="record.forbiddenStatus == 1" @click="showState(record.channelId, record.forbiddenStatus)">启用</a>
            <a v-else @click="showState(record.channelId, record.forbiddenStatus)">禁用</a>
          </span>
        </span>
      </s-table>
      <channel-modal ref="modal" @ok="handleOk" />
    </a-card>
    <no-authority v-if="!listEnable"></no-authority>
  </div>
</template>
<script>
import { STable } from '@/components'
import { getChannelList, deleteChannel, enableChannel, forbiddenBrand, getSlectCombox } from '@/api/enterprise/channel'
import ChannelModal from './modules/ChannelModal.vue'
import NoAuthority from './NoAuthority'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
import store from '@/store'

export default {
  name: 'TableList',
  components: {
    STable,
    ChannelModal,
    NoAuthority,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '操作',
          width: 60,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
          scopedSlots: { customRender: 'installType' },
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          scopedSlots: { customRender: 'enterpriseName' },
          align: 'center',
        },
        {
          title: '购买渠道名称',
          dataIndex: 'channelName',
          align: 'center',
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return getChannelList(Object.assign(parameter, this.queryParam))
      },
      data: [],
      enterpriseId: '', //企业id
      restaurantTypes: [],
      listEnable: checkPermission('enterprise:channel:list'),
      addEnable: checkPermission('enterprise:channel:add'),
      editEnabel: checkPermission('enterprise:channel:edit'),
      removeEnable: checkPermission('enterprise:channel:remove'),
      channelDetail: checkPermission('enterprise:channel:detail'),
    }
  },
  filters: {},
  async created() {
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.$refs.table.refresh(true)
    //   }
    // })
    // console.log(store.getters)
    this.enterpriseId = store.getters.enterpriseId
    this.restaurantTypes = []
    this.restaurantOperTypeMap = await getDictMap('install_type')
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes.push({ code: key, label: value })
    })
    // isAuthority 1   数据隔离
    getSlectCombox({ isAuthority: 1 }).then((res) => {
      // console.log(res.data)
      this.data = res.data
    })
  },
  // destroyed () {
  //   document.body.removeEventListener('keyup', e => {})
  // },
  methods: {
    qingkong() {
      this.queryParam = {}
    },
    handleBlur() {
      // console.log('blur');
    },
    handleFocus() {
      // console.log('focus');
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleChange(value) {
      // console.log(`selected ${value}`)
      this.queryParam.enterpriseId = value
    },
    showState(channelId, forbiddenStatus) {
      if (forbiddenStatus == 0) {
        forbiddenBrand({ channelId: channelId }).then((res) => {
          // console.log(res)
          if (res.code === 0) {
            this.$message.success('禁用成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (forbiddenStatus == 1) {
        enableChannel({ channelId: channelId }).then((res) => {
          // console.log(res)
          if (res.code === 0) {
            this.$message.success('启动成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    handleAdd() {
      console.log(this.enterpriseId)
      this.$refs.modal.add(this.enterpriseId)
    },
    handleShow(record) {
      this.$refs.modal.edit(record, 1)
    },
    handleEdit(record) {
      // console.log(record)
      this.$refs.modal.edit(record)
    },
    handleOk(value) {
      // console.log(value)
      if (value == 1) {
        this.$refs.table.refresh(true)
      } else {
        this.$refs.table.refresh()
      }
      // this.$refs.table.refresh(true)
      // console.log('handleSaveOk')
    },
    delByIds(channelId) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          deleteChannel({ channelId: channelId }).then((res) => {
            if (res.code === 0) {
              that.$message.success('删除成功')
              that.handleOk()
            } else {
              that.$message.error(res.msg)
            }
          })
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
  },
  watch: {
    /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
  },
}
</script>
<style scoped>
.ant-divider.ant-divider-horizontal {
  margin: 12px 0 !important;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px !important;
}
/deep/ .ant-table-content {
  width: 45%;
}
</style>
